export default __webpack_public_path__ + "static/media/hero.a51f8626.svg";